import { pdfjs } from 'react-pdf'
import workerUrl from '!!file-loader?name=static/media/pdf.worker.[contenthash].js!../../node_modules/react-pdf/node_modules/pdfjs-dist/build/pdf.worker.min.js'

// Emit the original worker: Babel runtime imports cannot execute in a browser worker.
pdfjs.GlobalWorkerOptions.workerSrc = workerUrl

export { pdfjs }
